import { isNotEmptyArray } from '@rumblefish/ui/Rumblefish23Theme';
import type { FC } from 'react';
import { JobPostSection } from '..';
import { StyledSection } from '../styles';
import type { OurOfferProps } from './OurOffer.types';
import {
  JobPostBenefitsGridContainer,
  JobPostBenefitsGridItem,
  BenefitIcon,
  BanefitName,
} from './styles';

export const OurOffer: FC<OurOfferProps> = ({ benefits }) => {
  if (!isNotEmptyArray(benefits)) {
    return null;
  }
  return (
    <StyledSection>
      <JobPostSection banner="Our offer" title="What’s in it for you?">
        <JobPostBenefitsGridContainer rows={Math.ceil(benefits.length / 3)}>
          {benefits.map((item) => (
            <JobPostBenefitsGridItem key={item.name}>
              <BenefitIcon src={item.icon} alt={item.name} />
              <BanefitName variant="regular_500">{item.name}</BanefitName>
            </JobPostBenefitsGridItem>
          ))}
        </JobPostBenefitsGridContainer>
      </JobPostSection>
    </StyledSection>
  );
};
